import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { map, Observable } from 'rxjs';
import { MerchantsApiService } from '@app/areas/merchants/services/merchants.api.service';

@Injectable()
export class MerchantAccessGuard {
  private readonly merchantsApiService = inject(MerchantsApiService);
  private readonly router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const coalitionId = Number(route.paramMap.get('coalitionId'));
    const merchantId = Number(route.paramMap.get('merchantId'));

    return this.merchantsApiService.getMerchants(coalitionId).pipe(
      map((merchants) => {
        const merchant = merchants.find((m) => m.MerchantId === merchantId);

        if (merchant && merchant.HasAccess === false) {
          this.router.navigate([`${coalitionId}/merchants/no-access/${merchantId}`], {
            state: { merchantName: merchant.Name },
          });
          return false;
        }

        return true;
      })
    );
  }
}
